import { useState, useEffect, useRef } from "react";
import { Send } from "lucide-react";

const INITIAL = [
  { from: "manager", text: "Labdien! Esmu Anna, jūsu personīgais menedžeris. Kā varu palīdzēt?", time: Date.now() - 86400000 },
  { from: "me", text: "Labdien! Vai varat sagatavot piedāvājumu tīrīšanas ķīmijai nākamajam ceturksnim?", time: Date.now() - 86000000 },
  { from: "manager", text: "Protams! Nosūtīšu piedāvājumu ar jūsu līguma cenām līdz rītdienai. Vai apjomi paliek kā iepriekš?", time: Date.now() - 85000000 },
];

const REPLIES = [
  "Paldies par ziņu! Apskatīšu un atbildēšu tuvākajā laikā. (DEMO atbilde)",
  "Sapratu! Sagatavošu informāciju un nosūtīšu uz jūsu e-pastu. (DEMO atbilde)",
  "Labs jautājums — precizēšu ar noliktavu un atgriezīšos ar atbildi. (DEMO atbilde)",
];

export default function AccChat() {
  const [msgs, setMsgs] = useState(() => {
    try { return JSON.parse(localStorage.getItem("demo_chat")) || INITIAL; } catch { return INITIAL; }
  });
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => { localStorage.setItem("demo_chat", JSON.stringify(msgs)); }, [msgs]);
  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    setMsgs((p) => [...p, { from: "me", text: t, time: Date.now() }]);
    setText("");
    setTimeout(() => {
      setMsgs((p) => [...p, { from: "manager", text: REPLIES[p.length % REPLIES.length], time: Date.now() }]);
    }, 1200);
  };

  return (
    <div data-testid="account-chat">
      <h2 className="text-xl font-extrabold uppercase mb-4">Saziņa ar menedžeri</h2>
      <div className="border border-[#E2E2E2]">
        <div className="flex items-center gap-3 p-4 border-b border-[#E2E2E2] bg-[#F5F5F5]">
          <span className="w-10 h-10 bg-[#111111] text-white flex items-center justify-center font-extrabold">AM</span>
          <div>
            <div className="text-sm font-bold">Anna Menedžere</div>
            <div className="text-xs text-[#1E9E45] font-semibold flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-[#1E9E45]" /> Tiešsaistē (demo)</div>
          </div>
        </div>
        <div className="h-80 overflow-y-auto p-4 space-y-3" data-testid="chat-messages">
          {msgs.map((m, i) => (
            <div key={i} className={`flex ${m.from === "me" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] px-4 py-2.5 text-sm ${m.from === "me" ? "bg-[#D0121A] text-white" : "bg-[#F5F5F5]"}`}>
                {m.text}
                <div className={`text-[10px] mt-1 ${m.from === "me" ? "text-white/60" : "text-[#6B6B6B]"}`}>{new Date(m.time).toLocaleString("lv-LV", { day: "numeric", month: "numeric", hour: "2-digit", minute: "2-digit" })}</div>
              </div>
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
        <form onSubmit={send} className="flex gap-2 p-4 border-t border-[#E2E2E2]">
          <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Raksti ziņu menedžerim…" data-testid="chat-input"
            className="flex-1 h-11 px-3 border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
          <button type="submit" data-testid="chat-send" aria-label="Sūtīt"
            className="bg-[#D0121A] hover:bg-[#A80D14] text-white px-5 flex items-center gap-2 font-bold text-sm transition-colors"><Send size={15} /> Sūtīt</button>
        </form>
      </div>
    </div>
  );
}
